<div>
    <app-spinner [spinnerName]="'NexioSpinner'"></app-spinner>
    <div class="networkinst1">
        <iframe id="nexioIframe" name="paymentNI" target="_parent" height="700" width="650" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts allow-top-navigation-by-user-activation allow-top-navigation"></iframe>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/payments/nexio.component.html